import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const TasksIcon: React.FC<Props> = ({
  color = "currentColor",
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      height={getDefaultHeight(svgProps, 32)}
      {...svgProps}
      fill={color}
    >
      <path d="M16.57 0c-8.499-0.023-15.407 6.829-15.43 15.328-0.011 2.867 0.779 5.678 2.28 8.116l-3.42 8.556 9.143-3.048c7.472 4.097 16.841 1.377 20.95-6.095s1.377-16.841-6.095-20.95c-2.28-1.253-4.831-1.908-7.427-1.908zM16.57 25.961c-0.948 0-1.716-0.768-1.716-1.716s0.768-1.716 1.716-1.716 1.716 0.768 1.716 1.716v0c0 0.948-0.768 1.716-1.716 1.716v0zM17.936 16.762v2.765c0 0.756-0.61 1.377-1.377 1.377-0.756 0-1.377-0.61-1.377-1.377v0-3.973c0-0.756 0.61-1.366 1.377-1.377 1.806 0 3.273-1.467 3.273-3.273s-1.467-3.273-3.273-3.273-3.273 1.467-3.273 3.273c0 0.756-0.61 1.377-1.377 1.377s-1.377-0.61-1.377-1.377c0-3.319 2.698-6.016 6.016-6.016s6.027 2.698 6.027 6.016c0 2.799-1.919 5.226-4.639 5.858v0z"></path>
    </SVG>
  );
};
